var map = {
	"./bank.svg": [
		69203,
		9203
	],
	"./bb.svg": [
		79732,
		9732
	],
	"./bradesco.svg": [
		87668,
		7668
	],
	"./btg.svg": [
		17706,
		7706
	],
	"./c6.svg": [
		94602,
		4602
	],
	"./caixa.svg": [
		23364,
		3364
	],
	"./inter.svg": [
		45300,
		5300
	],
	"./itau.svg": [
		951,
		951
	],
	"./mercadopago.svg": [
		47161,
		7161
	],
	"./nubank.svg": [
		77371,
		7371
	],
	"./pagseguro.svg": [
		25483,
		5483
	],
	"./picpay.svg": [
		69973,
		9973
	],
	"./safra.svg": [
		10652,
		652
	],
	"./santander.svg": [
		5781,
		5781
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 24785;
module.exports = webpackAsyncContext;